export default __webpack_public_path__ + "static/media/GE-AB.b4101190.svg";